import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from 'primereact/message'

import { setLastElement } from '../../../../../redux/Slices/scrollSlice';
import ScrollContainer from '../../../../SharedComponents/ScrollContainer'
import SearchInput from '../../../../SharedComponents/AddContentPopup/SearchInput';
import { isEmpty } from 'lodash';
import GroupCard from './GroupCard';
import { Checkbox } from 'primereact/checkbox';

function GroupsList({ ids, setIds }) {
    const { t } = useTranslation();
    const { isFetching, data, params } = useSelector((state) => state.scroll);
    const [allSelected, setAllSelected] = useState(false);

    const lastElementRef = useRef(null);
    const dispatch = useDispatch()

    useEffect(() => {
        if (lastElementRef.current) {
            dispatch(setLastElement(lastElementRef.current));
        }
    }, [lastElementRef.current]);


    useEffect(() => {
        if (data?.length > 0) {
            setAllSelected(ids.length === data.length);
        }
    }, [ids, data]);

    const selectAll = () => {
        if (!allSelected) {
            // Push all IDs
            const allIds = data?.map(item => String(item.id)) || [];
            setIds(allIds);
            setAllSelected(true);
        } else {
            // Clear selection
            setIds([]);
            setAllSelected(false);
        }
    };


    return (
        <>
            <div className="w-100 flex justify-center items-center ">
                <div className=" flex-grow   ">

                    <SearchInput isDisabled={data?.length === 0} />
                </div>

                <Checkbox name="campaign" className='me-2' onChange={selectAll} checked={allSelected} />

            </div>
            <ScrollContainer path={"/groups"} >
                {
                    data?.length === 0 && !isFetching ?
                        <div className="d-flex p-5 justify-content-center ">
                            <Message className="fw-bold fs-3 p-4 w-100" severity="warn" text={isEmpty(params?.search) ? t('show.show_no_groups_yet') : t('messages.no_results')} />
                        </div>
                        :
                        <>
                            {
                                data?.map((item, index) => {
                                    return (
                                        <div className={`card col-12  flex flex-row  items-center justify-between mb-2 p-2
                                                   ${ids.indexOf(`${item.id}`) !== -1 ? "  border-2 !border-[#8e90f5]" : ""}`}
                                            ref={index === data?.length - 1 ? lastElementRef : null}
                                            key={`${item.id}-${index}`}>
                                            <GroupCard ids={ids} setIds={setIds} item={item} />

                                        </div>)

                                })
                            }
                        </>
                }
            </ScrollContainer>
        </>
    )
}

export default GroupsList